import { params, arrayOf, shape, string } from '@thd-nucleus/data-sources';

export const storeSearchModel = {
  storeSearch: params({
    storeSearchInput: string().isRequired(),
    pagesize: string().isRequired()
  }).shape({
    stores: arrayOf(shape({
      address: shape({
        city: string(),
        state: string(),
        postalCode: string(),
        street: string()
      }),
      storeId: string(),
      name: string(),
      phone: string(),
      storeDetailsPageLink: string(),
      storeServicesPhone: string(),
      storeHours: shape({
        sunday: shape({ open: string(), close: string() }),
        monday: shape({ open: string(), close: string() })
      })
    }))
  })
};